
const vancouver = {
    lat: 49.1671284, 
    lng: -122.9868912
}

const edmonton = {
    lat: 53.536100, 
    lng: -113.494445
}

const calgary = {
    lat: 51.037593, 
    lng: -114.055446
}

const toronto = {
    lat: 43.743200, 
    lng: -79.404106
}

const montreal = {
    lat: 45.516918, 
    lng: -73.592835
}

const victoria = {
    lat: 48.4471568, 
    lng: -123.3496821
}

const ottawa = {
    lat: 45.342553, 
    lng: -75.720634
}

const london = {
    lat: 42.9849233,
    lng: -81.2452768
}

const Winnipeg = {
    lat: 49.853959,
    lng: -97.2923069
}

const halifax = {
    lat: 44.645923,
    lng: -63.631526
}

const burnaby = {
    lat: 49.1671284, 
    lng: -122.9868912
}

export function getMapCenterByCityId(cityId = 1){
    switch(cityId){
        case 1:
            return vancouver
        case 2:
            return toronto
        case 3:
            return edmonton
        case 4:
            return calgary
        case 5:
            return montreal
        case 6:
            return victoria
        case 7: 
            return ottawa
        case 14:
            return london
        case 16:
            return Winnipeg
        case 17:
            return halifax
        case 18:
            return burnaby
        default:
            return vancouver
    }
}